/* Craft Toolkit build 2026-08-03 2ca655ff3498 - GENERATED FILE.
   Source: landing-pages/carried-craft-tools/carried-craft-tools.html
   Do not edit here; rebuild with build-shopify.py. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ekct]');
  if (!root) return;

  var KEY_COUNTERS = 'ek_cct_counters';
  var KEY_INPUTS   = 'ek_cct_inputs';
  var KEY_UNIT     = 'ek_cct_unit';
  var KEY_TAB      = 'ek_cct_tab';

  /* Storage that never throws — private mode, blocked cookies, etc. */
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  var $  = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  /* ============================================================ NUMBERS */
  var CM = 2.54;          /* inches -> cm     */
  var YD = 0.9144;        /* yards  -> metres */

  var unit = store.get(KEY_UNIT) === 'cm' ? 'cm' : 'in';

  function num(el) {
    if (!el) return NaN;
    var v = parseFloat(el.value);
    return isFinite(v) ? v : NaN;
  }
  function pos(el) { var v = num(el); return v > 0 ? v : NaN; }
  function has(el) { return isFinite(pos(el)); }

  function rLen(v) { return unit === 'cm' ? Math.round(v * 10) / 10 : Math.round(v * 4) / 4; }
  function trim(v) {
    var s = (Math.round(v * 100) / 100).toFixed(2);
    return s.replace(/\.?0+$/, '');
  }
  function len(v)  { return trim(rLen(v)) + ' ' + unit; }
  function slen(v) {
    var r = rLen(v);
    return (r > 0 ? '+' : r < 0 ? '−' : '') + trim(Math.abs(r)) + ' ' + unit;
  }
  function lenUnitWord() { return unit === 'cm' ? 'm' : 'yd'; }
  function yarn(v) { return trim(Math.round(v)) + ' ' + lenUnitWord(); }
  function toIn(v) { return unit === 'cm' ? v / CM : v; }
  function fromIn(v) { return unit === 'cm' ? v * CM : v; }

  /* The span a gauge is quoted over: 4 inches, or 10 centimetres. */
  function gaugeSpan() { return unit === 'cm' ? 10 : 4; }

  /* ------------------------------------------------- answer panel states */
  /* Answer panels. `state` is '', 'good' or 'warn' - and ONLY where there is a
     real verdict. An informational readout is neither, and tinting it green
     would make green stop meaning anything. */
  var CHIP = { good: 'On track', warn: 'Worth a look' };

  function ans(el, html, state) {
    if (!el) return;
    el.className = 'ekct-out' + (state ? ' is-' + state : '');
    el.innerHTML = (CHIP[state] ? '<p class="ekct-chip">' + CHIP[state] + '</p>' : '') + html;
  }
  function wait(el, promise, missing) {
    if (!el) return;
    el.className = 'ekct-out is-waiting';
    el.innerHTML =
      '<div class="ekct-waitrow">' +
        '<span class="ekct-waitrow__mark" aria-hidden="true">?</span>' +
        '<div><p class="ekct-promise">' + promise + '</p>' +
        (missing.length
          ? '<p class="ekct-missing">Still need: ' + joinList(missing) + '.</p>'
          : '') +
        '</div>' +
      '</div>';
  }
  function joinList(a) {
    if (a.length === 1) return a[0];
    if (a.length === 2) return a[0] + ' and ' + a[1];
    return a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1];
  }
  function missingOf(pairs) {
    var out = [];
    for (var i = 0; i < pairs.length; i++) if (!pairs[i][1]) out.push(pairs[i][0]);
    return out;
  }

  /* ============================================================== GATE
     A velvet rope, not a vault. The code is readable in this source, and
     that is deliberate: the stakes are zero, and a code passed between two
     knitting friends is free word of mouth.

     To change the code, change this one line. Keep it ONE word, all letters,
     no digits - it gets read off a phone screen and retyped by hand, so
     anything with 0/O or 1/l in it will generate support email.
     Alternatives that fit the brand: EMMAKATE, SWIFTDRAW.
     ================================================================= */
  var UNLOCK_CODE  = 'CARRIED';
  var KEY_UNLOCKED = 'ek_cct_unlocked_v2';

  var gate    = $('[data-ekct-gate]');
  var tools   = $('[data-ekct-tools]');
  var form    = $('[data-ekct-form]');
  var codeIn  = $('#ekct-code');
  var codeErr = $('[data-ekct-error]');

  function unlock(focus) {
    gate.hidden = true;
    tools.hidden = false;
    store.set(KEY_UNLOCKED, '1');
    initCounters();
    if (focus) {
      var h = tools.querySelector('.ekct-h1');
      if (h) { h.setAttribute('tabindex', '-1'); h.focus(); }
    }
  }

  /* Forgiving on purpose: case, spaces, hyphens and stray punctuation are all
     stripped before comparing. Someone retyping from an email should not fail
     on a trailing space. */
  function normalise(v) {
    return (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (normalise(codeIn.value) === UNLOCK_CODE) {
      codeErr.hidden = true;
      unlock(true);
    } else {
      codeErr.hidden = false;
      codeIn.select();
    }
  });

  /* ============================================================== TABS */
  var tabs   = $$('[data-tab]');
  var panels = $$('[data-panel]');

  function isTab(name) {
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('data-tab') === name) return true;
    }
    return false;
  }

  function selectTab(name, focus) {
    /* A stored name from an older version would otherwise hide every panel
       and leave a returning visitor staring at nothing. */
    if (!isTab(name)) name = tabs.length ? tabs[0].getAttribute('data-tab') : 'size';
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-tab') === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== name;
    });
    store.set(KEY_TAB, name);
  }

  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      selectTab(t.getAttribute('data-tab'), false);
    });
    t.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      var j = -1;
      if (d) j = (i + d + tabs.length) % tabs.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = tabs.length - 1;
      if (j < 0) return;
      e.preventDefault();
      selectTab(tabs[j].getAttribute('data-tab'), true);
    });
  });

  /* ================================================= PERSIST + UNITS */
  var fields = $$('[data-persist]');

  function saveInputs() {
    var out = {};
    fields.forEach(function (el) { if (el.value !== '') out[el.id] = el.value; });
    store.set(KEY_INPUTS, JSON.stringify(out));
    store.set(KEY_UNIT, unit);
  }

  function restoreInputs() {
    var raw = store.get(KEY_INPUTS);
    if (!raw) return;
    try {
      var saved = JSON.parse(raw);
      fields.forEach(function (el) {
        if (Object.prototype.hasOwnProperty.call(saved, el.id)) el.value = saved[el.id];
      });
    } catch (e) { /* corrupt blob — start clean rather than fail */ }
  }

  /* Never leave a visitor's own value hidden inside a closed disclosure. */
  function openFilledDisclosures() {
    $$('.ekct-more').forEach(function (d) {
      var kids = Array.prototype.slice.call(d.querySelectorAll('input, select'));
      for (var i = 0; i < kids.length; i++) {
        if (kids[i].value !== '') { d.open = true; return; }
      }
    });
  }

  function paintUnitLabels() {
    $$('[data-ekct-suffix]').forEach(function (s) { s.textContent = unit; });
    $$('[data-ekct-lensuffix]').forEach(function (s) { s.textContent = lenUnitWord(); });
    $$('[data-ekct-unit]').forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-ekct-unit') === unit);
    });
    /* A placeholder of "4" beside a "cm" suffix is nonsense guidance. */
    $$('[data-ph-cm]').forEach(function (el) {
      el.setAttribute('placeholder',
        el.getAttribute(unit === 'cm' ? 'data-ph-cm' : 'data-ph-in') || '');
    });
  }

  var YARN_LEN_IDS = ['#ekct-y-sl', '#ekct-y-total', '#ekct-y-new'];

  $$('[data-ekct-unit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var next = btn.getAttribute('data-ekct-unit');
      if (next === unit) return;

      /* Lengths convert. Counts, grams and gauge numbers do not. */
      var lf = next === 'cm' ? CM : 1 / CM;
      $$('[data-conv]').forEach(function (el) {
        if (el.value !== '') {
          var v = parseFloat(el.value) * lf;
          el.value = next === 'cm' ? Math.round(v * 10) / 10 : Math.round(v * 4) / 4;
        }
      });
      /* Yarn lengths are yards or metres, a separate scale. */
      var yf = next === 'cm' ? YD : 1 / YD;
      YARN_LEN_IDS.forEach(function (sel) {
        var el = $(sel);
        if (el && el.value !== '') el.value = Math.round(parseFloat(el.value) * yf);
      });

      unit = next;
      paintUnitLabels();
      saveInputs();
      recalcAll();
    });
  });

  /* ========================================================= EXAMPLES
     Deliberately NOT pre-filled on load. Someone could read an example's
     answer as their own, and a wrong answer here costs weeks of knitting.
     One tap shows a full worked answer instead.
     {len:} converts as a measurement, {yd:} as a yarn length. */
  var EXAMPLES = {
    size: {
      'ekct-g-sts': 18, 'ekct-g-stsover': { len: 4 },
      'ekct-g-rows': 24, 'ekct-g-rowsover': { len: 4 },
      'ekct-g-psts': 20, 'ekct-g-pstsover': { len: 4 },
      'ekct-g-count': 180,
      'ekct-g-tw': { len: 40 }, 'ekct-g-tl': { len: 60 },
      'ekct-g-mult': 8, 'ekct-g-plus': 2
    },
    fit: {
      'ekct-craft': 'knit', 'ekct-garment': 'pullover',
      'ekct-body': { len: 38 }, 'ekct-upper': { len: 35 },
      'ekct-arm': { len: 13 }, 'ekct-want': 'classic',
      'ekct-finished': { len: 41 }, 'ekct-sleeve': { len: 15 }
    },
    yarn: {
      'ekct-y-sg': 100, 'ekct-y-sl': { yd: 220 }, 'ekct-y-rg': 38,
      'ekct-y-gpr': 2.4, 'ekct-y-need': 40,
      'ekct-y-total': { yd: 1100 }, 'ekct-y-new': { yd: 230 }
    },
    hat: {
      'ekct-h-who': '22', 'ekct-h-craft': 'knit', 'ekct-h-style': 'fitted',
      'ekct-h-sts': 18, 'ekct-h-stsover': { len: 4 }, 'ekct-h-mult': 4
    }
  };

  $$('[data-ekct-example]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var map = EXAMPLES[btn.getAttribute('data-ekct-example')];
      if (!map) return;
      Object.keys(map).forEach(function (id) {
        var el = root.querySelector('#' + id);
        if (!el) return;
        var v = map[id];
        if (v && typeof v === 'object') {
          if ('len' in v) el.value = unit === 'cm' ? Math.round(v.len * CM * 10) / 10 : v.len;
          else if ('yd' in v) el.value = unit === 'cm' ? Math.round(v.yd * YD) : v.yd;
        } else {
          el.value = v;
        }
      });
      /* The example fills optional fields too — show them, don't hide them. */
      openFilledDisclosures();
      saveInputs();
      recalcAll();
    });
  });

  /* ===================================== TOOL 1 — STITCHES & SIZE */
  var gSts      = $('#ekct-g-sts');
  var gStsOver  = $('#ekct-g-stsover');
  var gRows     = $('#ekct-g-rows');
  var gRowsOver = $('#ekct-g-rowsover');
  var gPSts     = $('#ekct-g-psts');
  var gPStsOver = $('#ekct-g-pstsover');
  var gCount    = $('#ekct-g-count');
  var gTW       = $('#ekct-g-tw');
  var gTL       = $('#ekct-g-tl');
  var gMult     = $('#ekct-g-mult');
  var gPlus     = $('#ekct-g-plus');

  var outGauge  = $('[data-ekct-g-gauge]');
  var outDiff   = $('[data-ekct-g-diff]');
  var outWidth  = $('[data-ekct-g-width]');
  var outTarget = $('[data-ekct-g-target]');

  function perOver(a, b) {
    var s = pos(a), w = pos(b);
    return (s && w) ? s / toIn(w) : NaN;
  }
  function myStsPerIn()  { return perOver(gSts, gStsOver); }
  function myRowsPerIn() { return perOver(gRows, gRowsOver); }
  function patStsPerIn() { return perOver(gPSts, gPStsOver); }

  /* Stitches per inch -> stitches over the span gauge is normally quoted
     over. In centimetres that span is 10cm, which is 3.937in, NOT 10in. */
  function overSpan(perIn) { return perIn * toIn(gaugeSpan()); }

  /* Nearest count that satisfies "multiple of M, plus P". */
  function toRepeat(n, mult, plus) {
    if (!(mult > 1)) return Math.max(1, Math.round(n));
    var k = Math.round((n - plus) / mult);
    if (k < 1) k = 1;
    return k * mult + plus;
  }

  function gaugeMissing() {
    return missingOf([
      ['your stitch count', has(gSts)],
      ['how wide you measured it', has(gStsOver)]
    ]);
  }

  function calcGauge() {
    var sIn = myStsPerIn(), rIn = myRowsPerIn();
    var span = gaugeSpan();

    if (!isFinite(sIn)) {
      wait(outGauge, 'Your real gauge, in stitches per ' + span + ' ' + unit +
        ' — the number every answer below is built on.', gaugeMissing());
    } else {
      var html = '<span class="ekct-big">' +
        trim(Math.round(overSpan(sIn) * 10) / 10) + ' sts to ' + span + ' ' + unit +
        '</span>';
      html += isFinite(rIn)
        ? '<p>And ' + trim(Math.round(overSpan(rIn) * 10) / 10) + ' rows to ' +
          span + ' ' + unit + '.</p>'
        : '<p>Add your row count above to check length as well as width.</p>';
      ans(outGauge, html);
    }

    /* --- how far off the pattern --- */
    var pIn = patStsPerIn();
    if (!isFinite(sIn) || !isFinite(pIn)) {
      wait(outDiff, 'Whether you are on gauge — and if not, how much bigger or ' +
        'smaller everything will come out.',
        gaugeMissing().concat(missingOf([
          ['the pattern’s stitch gauge', has(gPSts)],
          ['how wide the pattern measures it', has(gPStsOver)]
        ])));
    } else {
      /* Looser gauge = fewer stitches per inch = everything comes out bigger.
         Size ratio is the inverse of the stitches-per-inch ratio. */
      var ratio = pIn / sIn;
      var pct = Math.round(Math.abs(ratio - 1) * 1000) / 10;
      if (pct < 0.5) {
        ans(outDiff, '<span class="ekct-big">You are on gauge.</span>' +
          '<p>Follow the pattern’s stitch counts as written.</p>', 'good');
      } else {
        var looser = ratio > 1;
        ans(outDiff,
          '<span class="ekct-big">' + trim(pct) + '% ' + (looser ? 'looser' : 'tighter') +
          ' than the pattern</span>' +
          '<p>Everything will come out about <strong>' + trim(pct) + '% ' +
          (looser ? 'bigger' : 'smaller') + '</strong> if you follow the stitch counts as ' +
          'written. Change ' + (looser ? 'down' : 'up') + ' a needle or hook size and swatch ' +
          'again, or use the numbers below instead.</p>',
          pct > 5 ? 'warn' : '');
      }
    }

    /* --- pattern's cast-on -> what it really measures --- */
    var n = pos(gCount);
    if (!isFinite(sIn) || !isFinite(n)) {
      wait(outWidth, 'What the pattern’s cast-on will actually measure at your gauge — ' +
        'before you work forty rows and find out the hard way.',
        gaugeMissing().concat(missingOf([['the cast-on number', has(gCount)]])));
    } else {
      var mine = n / sIn;
      var h2 = '<span class="ekct-big">' + len(fromIn(mine)) + ' wide</span>';
      var state = '';
      if (isFinite(pIn)) {
        var meant = n / pIn;
        var gap = mine - meant;
        var onIt = Math.abs(gap) < 0.125;
        /* This IS a verdict: either the cast-on lands on the intended width or
           it does not, and 5% out on a blanket is a hand-span. */
        state = onIt ? 'good' : (Math.abs(gap) / meant > 0.05 ? 'warn' : '');
        h2 += '<p>The pattern intends <strong>' + len(fromIn(meant)) + '</strong>. ' +
              (onIt
                ? 'You land on it.'
                : 'You are <strong>' + len(fromIn(Math.abs(gap))) + '</strong> ' +
                  (gap > 0 ? 'over' : 'under') + '.') + '</p>';
      } else {
        h2 += '<p>Add the pattern’s gauge above to see what it was aiming for.</p>';
      }
      ans(outWidth, h2, state);
    }

    /* --- target size -> counts --- */
    var tw = pos(gTW), tl = pos(gTL);
    if (!isFinite(sIn) || (!isFinite(tw) && !isFinite(tl))) {
      wait(outTarget, 'Exactly how many stitches to cast on for the size you want, ' +
        'rounded to fit your stitch repeat.',
        gaugeMissing().concat(missingOf([
          ['the width you want', isFinite(tw) || isFinite(tl)]
        ])));
    } else {
      var mult = Math.max(1, Math.round(num(gMult)) || 1);
      var plus = Math.max(0, Math.round(num(gPlus)) || 0);
      var parts = [];

      if (isFinite(tw)) {
        var raw = toIn(tw) * sIn;
        var sts = toRepeat(raw, mult, plus);
        var line = '<span class="ekct-big">Cast on ' + sts + ' stitches</span>';
        if (mult > 1) {
          line += '<p>The nearest multiple of ' + mult + (plus ? ' plus ' + plus : '') +
                  ' to the ' + Math.round(raw) + ' your gauge asks for. That gives ' +
                  len(fromIn(sts / sIn)) + ' rather than ' + len(tw) + '.</p>';
        }
        parts.push(line);
      }
      if (isFinite(tl)) {
        parts.push(isFinite(rIn)
          ? '<p><strong>' + Math.round(toIn(tl) * rIn) + ' rows</strong> for ' + len(tl) +
            ' of length.</p>'
          : '<p>Add your row gauge above and this will give you the row count too.</p>');
      }
      ans(outTarget, parts.join(''));
    }
  }

  /* ============================================ TOOL 2 — WILL IT FIT
     Ease = finished garment measurement - body measurement. Negative ease
     means the garment is smaller than the body and stretches to fit.

     Bands come from the Craft Yarn Council Bust/Chest Fit and Ease Chart:
       very close fitting  2-4in less than actual
       close fitting       zero ease, actual measurement
       classic fit         2-4in more
       loose fit           4-6in more
       oversized           6in+ more
     CYC anchors those as targets and leaves gaps between them, so the
     boundaries below sit at the midpoints between adjacent anchors. The
     targets are CYC's; only the dividing lines are interpolated.
     ================================================================ */
  var BANDS = [
    { key: 'veryclose', label: 'Very close fitting', min: -Infinity, max: -1.5, target: -3 },
    { key: 'close',     label: 'Close fitting',      min: -1.5, max: 1.5, target: 0 },
    { key: 'classic',   label: 'Classic fit',        min: 1.5,  max: 4,   target: 3 },
    { key: 'loose',     label: 'Loose fit',          min: 4,    max: 6,   target: 5 },
    { key: 'oversized', label: 'Oversized',          min: 6,    max: Infinity, target: 8 }
  ];
  function bandFor(easeIn) {
    for (var i = 0; i < BANDS.length; i++) {
      if (easeIn >= BANDS[i].min && easeIn < BANDS[i].max) return BANDS[i];
    }
    return BANDS[BANDS.length - 1];
  }
  function bandByKey(k) {
    for (var i = 0; i < BANDS.length; i++) if (BANDS[i].key === k) return BANDS[i];
    return BANDS[2];
  }

  /* A cardigan's front bands and overlap consume ease, so the same look
     needs more room than a pullover. One inch is designer guidance, not a
     published standard — it is shown in the output so it is never hidden. */
  var CARDIGAN_EXTRA_IN = 1;

  /* Negative-ease ceilings, as a share of the body measurement. Knitting
     recovers 10-20%; crochet fabric is denser and recovers 5-10%. Designer
     consensus, not a CYC standard. */
  var NEG_LIMIT = { knit: 0.20, crochet: 0.10 };

  /* Minimum breathing room at the widest part of the arm. Rule of thumb. */
  var SLEEVE_MIN = { knit: 1.5, crochet: 2 };

  var fBody     = $('#ekct-body');
  var fUpper    = $('#ekct-upper');
  var fArm      = $('#ekct-arm');
  var fFinished = $('#ekct-finished');
  var fSleeve   = $('#ekct-sleeve');
  var fWant     = $('#ekct-want');
  var fCraft    = $('#ekct-craft');
  var fGarment  = $('#ekct-garment');

  var fitResult = $('[data-ekct-fit-result]');
  var fitWait   = $('[data-ekct-fit-wait]');
  var fitAnswer = $('[data-ekct-fit-answer]');
  var fitBadge  = $('[data-ekct-fit-badge]');
  var fitHead   = $('[data-ekct-fit-headline]');
  var fitDetail = $('[data-ekct-fit-detail]');
  var fitAction = $('[data-ekct-fit-action]');
  var fitNotes  = $('[data-ekct-fit-notes]');

  function calcFit() {
    var body = pos(fBody), fin = pos(fFinished);

    if (!isFinite(body) || !isFinite(fin)) {
      fitResult.className = 'ekct-result is-waiting';
      fitWait.hidden = false;
      fitAnswer.hidden = true;
      fitWait.innerHTML =
        '<span class="ekct-waitrow__mark" aria-hidden="true">?</span>' +
        '<div><p class="ekct-promise">Whether this size will fit you — and if not, ' +
        'the finished measurement to look for instead.</p>' +
        '<p class="ekct-missing">Still need: ' + joinList(missingOf([
          ['your full bust', isFinite(body)],
          ['the pattern’s finished bust', isFinite(fin)]
        ])) + '.</p></div>';
      return;
    }

    fitWait.hidden = true;
    fitAnswer.hidden = false;

    var craft    = fCraft.value === 'crochet' ? 'crochet' : 'knit';
    var cardigan = fGarment.value === 'cardigan';

    var bodyIn = toIn(body);
    var finIn  = toIn(fin);
    var easeIn = finIn - bodyIn;

    var actual = bandFor(easeIn);
    var wanted = bandByKey(fWant.value);
    var match  = actual.key === wanted.key;

    fitResult.className = 'ekct-result' + (match ? ' is-match' : '');
    fitBadge.textContent = actual.label;

    fitHead.textContent = match
      ? 'That is the fit you asked for. Cast on.'
      : 'This will not sit the way you want.';

    fitDetail.innerHTML =
      'Ease is <strong>' + slen(fromIn(easeIn)) + '</strong> at the full bust. That reads as ' +
      actual.label.toLowerCase() + ', and you asked for ' + wanted.label.toLowerCase() + '.';

    var targetEase = wanted.target + (cardigan ? CARDIGAN_EXTRA_IN : 0);
    var targetFin  = bodyIn + targetEase;

    if (match && !cardigan) {
      fitAction.textContent =
        'Nothing to change. Check the sleeve and the length against the schematic too.';
    } else {
      var diff = targetFin - finIn;
      if (Math.abs(diff) < 0.25) {
        fitAction.innerHTML = 'Close enough — the size you picked lands on <strong>' +
          len(fromIn(targetFin)) + '</strong>, which is what you want.';
      } else {
        fitAction.innerHTML =
          'For ' + wanted.label.toLowerCase() + ', look for a size with a finished bust near ' +
          '<strong>' + len(fromIn(targetFin)) + '</strong> — about ' +
          len(fromIn(Math.abs(diff))) + ' ' + (diff > 0 ? 'bigger' : 'smaller') +
          ' than the one you picked.' +
          (cardigan ? ' That includes ' + len(fromIn(CARDIGAN_EXTRA_IN)) +
                      ' added because it buttons up the front.' : '');
      }
    }

    /* ---- notes: the things that actually ruin a sweater ---- */
    var notes = [];

    if (easeIn < 0) {
      var share = Math.abs(easeIn) / bodyIn;
      if (share > NEG_LIMIT[craft]) {
        notes.push('<strong>That is a lot of negative ease for ' + craft + '.</strong> You are ' +
          Math.round(share * 100) + '% under your own measurement. ' +
          (craft === 'crochet'
            ? 'Crochet fabric is dense and does not spring back the way knitting does — keep it under about 10%, or the fabric will strain and the stitches will gap.'
            : 'Knitting takes 10 to 20% before it stops recovering. Past that it will stretch out and stay stretched.') +
          ' Guidance from designers, not a published standard.');
      } else if (craft === 'crochet') {
        notes.push('Negative ease in crochet only works if the stitch pattern has give. A solid single-crochet fabric has almost none.');
      }
    }

    var upper = pos(fUpper);
    if (isFinite(upper)) {
      var upperIn = toIn(upper);
      var gap2 = bodyIn - upperIn;
      notes.push('At the <strong>upper bust</strong> the same size gives ' +
        slen(fromIn(finIn - upperIn)) + ' of ease. That is what decides the shoulders and neckline.');
      if (gap2 > 2) {
        notes.push('<strong>Your full bust is ' + len(fromIn(gap2)) +
          ' bigger than your upper bust.</strong> Pick the size by your upper bust — ' +
          'near <strong>' + len(fromIn(upperIn + targetEase)) + '</strong> finished — and add ' +
          'bust darts or a few short rows for the chest. Size by the full bust and the ' +
          'shoulders and neck will be too wide, which is the one thing you cannot alter afterwards.');
      }
    } else {
      notes.push('Measure your <strong>upper bust</strong> too, high under the arms. It takes ten seconds and it is the measurement that decides whether the shoulders fit.');
    }

    var arm = pos(fArm), sleeve = pos(fSleeve);
    if (isFinite(arm) && isFinite(sleeve)) {
      var sleeveEase = toIn(sleeve) - toIn(arm);
      var need = SLEEVE_MIN[craft];
      notes.push(sleeveEase < need
        ? '<strong>The sleeve is tight.</strong> ' + slen(fromIn(sleeveEase)) +
          ' at the upper arm. Allow at least ' + len(fromIn(need)) + ' in ' + craft +
          ' or you will not be able to reach forward. Widen the sleeve without touching the ' +
          'body — work the increases sooner and stop later.'
        : 'Sleeve has ' + slen(fromIn(sleeveEase)) + ' at the upper arm. That is enough room.');
    }

    if (cardigan && match) {
      notes.push('It buttons, so aim ' + len(fromIn(CARDIGAN_EXTRA_IN)) +
        ' looser than the pullover version of the same look — near ' +
        len(fromIn(targetFin)) + ' finished.');
    }

    fitNotes.innerHTML = notes.map(function (n) { return '<li>' + n + '</li>'; }).join('');
    fitNotes.hidden = !notes.length;
  }

  /* ============================================ TOOL 3 — ENOUGH YARN */
  var ySG    = $('#ekct-y-sg');
  var ySL    = $('#ekct-y-sl');
  var yRG    = $('#ekct-y-rg');
  var yGPR   = $('#ekct-y-gpr');
  var yNeed  = $('#ekct-y-need');
  var yTotal = $('#ekct-y-total');
  var yNew   = $('#ekct-y-new');

  var outYLeft = $('[data-ekct-y-left]');
  var outYRows = $('[data-ekct-y-rows]');
  var outYSub  = $('[data-ekct-y-sub]');

  function calcYarn() {
    var sg = pos(ySG), sl = pos(ySL), rg = pos(yRG);

    if (!isFinite(sg) || !isFinite(sl) || !isFinite(rg)) {
      wait(outYLeft, 'Exactly how much yarn you have left, in ' +
        (unit === 'cm' ? 'metres' : 'yards') + ' — worked out from its weight.',
        missingOf([
          ['a full skein’s weight', isFinite(sg)],
          ['its length', isFinite(sl)],
          ['what’s left on the scale', isFinite(rg)]
        ]));
    } else {
      ans(outYLeft,
        '<span class="ekct-big">' + yarn(rg / sg * sl) + ' left</span>' +
        '<p>That is ' + trim(Math.round(rg / sg * 100) / 100) + ' of a skein. Weigh again ' +
        'whenever you want a fresh number — it costs nothing to check.</p>');
    }

    var gpr = pos(yGPR);
    if (!isFinite(rg) || !isFinite(gpr)) {
      wait(outYRows, 'Whether what’s left actually finishes the job, and by how ' +
        'much you are over or short.',
        missingOf([
          ['what’s left on the scale', isFinite(rg)],
          ['the grams one row uses', isFinite(gpr)]
        ]));
    } else {
      var can = Math.floor(rg / gpr);
      var needRows = pos(yNeed);
      needRows = isFinite(needRows) ? Math.round(needRows) : NaN;
      if (!isFinite(needRows)) {
        ans(outYRows,
          '<span class="ekct-big">' + can + ' more rows</span>' +
          '<p>At ' + trim(gpr) + ' g a row, on what you have left. Add the rows still to ' +
          'go and this will tell you whether it finishes.</p>');
      } else if (can >= needRows) {
        var spare = can - needRows;
        ans(outYRows,
          '<span class="ekct-big">Yes — with ' + spare +
          (spare === 1 ? ' row' : ' rows') + ' to spare</span>' +
          '<p>You need ' + needRows + ' and you have enough for ' + can + '. ' +
          (spare <= 3 ? 'It is close, so work the last rows in daylight and keep the ball band.'
                      : 'Go on.') + '</p>',
          'good');
      } else {
        var shortRows = needRows - can;
        var shortG = Math.ceil(shortRows * gpr);
        var shortLen = (isFinite(sg) && isFinite(sl))
          ? ', roughly ' + yarn(shortG / sg * sl) : '';
        ans(outYRows,
          '<span class="ekct-big">No — ' + shortRows +
          (shortRows === 1 ? ' row' : ' rows') + ' short</span>' +
          '<p>You are about <strong>' + shortG + ' g</strong> under' + shortLen +
          '. Options: shorten the piece by ' + shortRows +
          (shortRows === 1 ? ' row' : ' rows') +
          ', work the last rows in a second colour on purpose, or find the dye lot now ' +
          'rather than at midnight.</p>',
          'warn');
      }
    }

    var total = pos(yTotal), perSkein = pos(yNew);
    if (!isFinite(total) || !isFinite(perSkein)) {
      wait(outYSub, 'How many skeins of a different yarn to buy, with the headroom ' +
        'you actually want.',
        missingOf([
          ['the pattern’s total yardage', isFinite(total)],
          ['the new skein’s length', isFinite(perSkein)]
        ]));
    } else {
      var needSkeins = Math.ceil(total / perSkein);
      var safe = Math.ceil(total * 1.1 / perSkein);
      ans(outYSub,
        '<span class="ekct-big">' + needSkeins +
        (needSkeins === 1 ? ' skein' : ' skeins') + '</span>' +
        '<p>Buy <strong>' + safe + '</strong> if you are changing the stitch pattern, ' +
        'lengthening anything, or the yarn is discontinued — that is the same total plus a ' +
        'tenth. Buy them in one dye lot while you can.</p>' +
        '<p>Match the yarn weight and swatch before you commit. Yardage tells you how much; ' +
        'only a swatch tells you whether it behaves the same.</p>');
    }
  }

  /* ================================================ TOOL 4 — HAT SIZE
     Head sizes are the CYC Head Circumference Chart. A hat has to be
     smaller than the head to stay on; how much smaller depends on how far
     the fabric recovers, which is why knit and crochet differ here.
     This tab carries its OWN gauge fields — you cannot see the Size tab
     from in here, so it must not silently depend on it.
     ================================================================= */
  var HAT_RANGE = {
    '10.5': '9 to 12 in · 23 to 30.5 cm',
    '15':   '14 to 16 in · 35.5 to 40.5 cm',
    '17':   '16 to 18 in · 40.5 to 46 cm',
    '19':   '18 to 20 in · 45.5 to 51 cm',
    '21':   '20 to 22 in · 51 to 56 cm',
    '22':   '21 to 23 in · 53 to 58.5 cm',
    '23':   '22 to 24 in · 56 to 61 cm'
  };
  /* Fitted beanie negative ease. Slouchy sits at zero and gains height. */
  var HAT_NEG = { knit: 0.10, crochet: 0.05 };

  var hWho     = $('#ekct-h-who');
  var hOwnWrap = $('[data-ekct-h-ownwrap]');
  var hOwn     = $('#ekct-h-own');
  var hCraft   = $('#ekct-h-craft');
  var hStyle   = $('#ekct-h-style');
  var hSts     = $('#ekct-h-sts');
  var hStsOver = $('#ekct-h-stsover');
  var hMult    = $('#ekct-h-mult');
  var hRange   = $('[data-ekct-h-range]');
  var outHat   = $('[data-ekct-h-out]');

  function calcHat() {
    var own = hWho.value === 'own';
    hOwnWrap.hidden = !own;
    hRange.textContent = own ? 'Around the head, just above the ears.'
                             : (HAT_RANGE[hWho.value] || '') + ' · Craft Yarn Council';

    var headIn = own ? toIn(pos(hOwn)) : parseFloat(hWho.value);

    if (!isFinite(headIn) || headIn <= 0) {
      wait(outHat, 'The finished size to make this hat, and what to cast on.',
        ['the head measurement']);
      return;
    }

    var craft  = hCraft.value === 'crochet' ? 'crochet' : 'knit';
    var slouch = hStyle.value === 'slouch';
    var negPct = slouch ? 0 : HAT_NEG[craft];
    var circIn = headIn * (1 - negPct);
    /* Rule of thumb, not a standard: a fitted beanie is about a third of the
       head circumference tall, plus an inch if you want to fold a brim. */
    var heightIn = headIn / 3 + (slouch ? 2.5 : 1);

    var html = '<span class="ekct-big">Finish it at ' + len(fromIn(circIn)) + ' around</span>';

    html += slouch
      ? '<p>Slouchy, so no negative ease — same as the head, with the extra length doing the work.</p>'
      : '<p>That is ' + Math.round(negPct * 100) + '% under the ' + len(fromIn(headIn)) +
        ' head, which is what ' + craft + ' fabric recovers from. ' +
        (craft === 'crochet'
          ? 'Crochet gets half the negative ease knitting does — it is denser and springs back less.'
          : 'Knit ribbing can take more if the whole hat is ribbed.') + '</p>';

    var sIn = perOver(hSts, hStsOver);
    if (isFinite(sIn)) {
      var mult = Math.max(1, Math.round(num(hMult)) || 1);
      var sts = toRepeat(circIn * sIn, mult, 0);
      html += '<p><strong>Cast on ' + sts + ' stitches</strong>' +
              (mult > 1 ? ', rounded to a multiple of ' + mult : '') + '.</p>';
    } else {
      html += '<p>Open "Give me a stitch count too" above and this will work out the cast-on.</p>';
    }
    html += '<p>Work it about <strong>' + len(fromIn(heightIn)) +
            '</strong> tall before you start the crown. That height is a rule of thumb, ' +
            'not a standard — try it on if you can.</p>';

    ans(outHat, html);
  }

  /* ============================================== TOOL 5 — COUNTERS */
  var DEFAULTS = [
    { name: 'Project one',   count: 0, repeat: 0 },
    { name: 'Project two',   count: 0, repeat: 0 },
    { name: 'Project three', count: 0, repeat: 0 }
  ];
  var counters = null;
  var wrap = $('[data-ekct-counters]');
  var built = false;

  function loadCounters() {
    var raw = store.get(KEY_COUNTERS);
    if (!raw) return JSON.parse(JSON.stringify(DEFAULTS));
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed) || parsed.length !== 3) throw 0;
      return parsed.map(function (c, i) {
        return {
          name: typeof c.name === 'string' && c.name ? c.name : DEFAULTS[i].name,
          count: Math.max(0, parseInt(c.count, 10) || 0),
          repeat: Math.max(0, parseInt(c.repeat, 10) || 0)
        };
      });
    } catch (e) {
      return JSON.parse(JSON.stringify(DEFAULTS));
    }
  }
  function saveCounters() { store.set(KEY_COUNTERS, JSON.stringify(counters)); }

  function repeatText(c) {
    if (!c.repeat || c.repeat < 2) return '';
    if (c.count === 0) return 'Row 0 of ' + c.repeat;
    var p = ((c.count - 1) % c.repeat) + 1;
    return 'Row ' + p + ' of ' + c.repeat + ' in the repeat';
  }
  function paint(i) {
    var el = wrap.children[i];
    if (!el) return;
    el.querySelector('[data-count]').textContent = counters[i].count;
    el.querySelector('[data-inrepeat]').textContent = repeatText(counters[i]);
  }

  function initCounters() {
    if (built) return;
    built = true;
    counters = loadCounters();

    counters.forEach(function (c, i) {
      var el = document.createElement('div');
      el.className = 'ekct-counter';
      el.innerHTML =
        '<div class="ekct-counter__top">' +
          '<input class="ekct-counter__name" type="text" maxlength="28"' +
            ' aria-label="Project name" data-name>' +
          '<span class="ekct-counter__repeat">' +
            '<label for="ekct-rep-' + i + '">Repeat every</label>' +
            '<input id="ekct-rep-' + i + '" type="number" min="0" max="999"' +
              ' inputmode="numeric" data-repeat>' +
            '<span>rows</span>' +
          '</span>' +
        '</div>' +
        '<div class="ekct-counter__main">' +
          '<button class="ekct-step ekct-step--down" type="button" data-down' +
            ' aria-label="Down one row">&minus;</button>' +
          '<div class="ekct-counter__readout">' +
            '<span class="ekct-counter__count" data-count aria-live="polite">0</span>' +
            '<p class="ekct-counter__inrepeat" data-inrepeat></p>' +
          '</div>' +
          '<button class="ekct-step ekct-step--up" type="button" data-up' +
            ' aria-label="Up one row">+</button>' +
        '</div>' +
        '<div class="ekct-counter__foot">' +
          '<button class="ekct-counter__reset" type="button" data-reset>' +
            'Reset this one</button>' +
        '</div>';

      wrap.appendChild(el);

      var nameEl = el.querySelector('[data-name]');
      var repEl  = el.querySelector('[data-repeat]');
      nameEl.value = c.name;
      repEl.value  = c.repeat ? c.repeat : '';

      nameEl.addEventListener('input', function () {
        counters[i].name = nameEl.value;
        saveCounters();
      });
      repEl.addEventListener('input', function () {
        counters[i].repeat = Math.max(0, parseInt(repEl.value, 10) || 0);
        saveCounters();
        paint(i);
      });
      el.querySelector('[data-up]').addEventListener('click', function () {
        counters[i].count += 1;
        saveCounters();
        paint(i);
      });
      el.querySelector('[data-down]').addEventListener('click', function () {
        counters[i].count = Math.max(0, counters[i].count - 1);
        saveCounters();
        paint(i);
      });
      el.querySelector('[data-reset]').addEventListener('click', function () {
        if (counters[i].count === 0) return;
        if (!window.confirm('Set ' + (counters[i].name || 'this counter') + ' back to zero?')) return;
        counters[i].count = 0;
        saveCounters();
        paint(i);
      });

      paint(i);
    });
  }

  /* ============================================================ WIRING */
  function recalcAll() { calcGauge(); calcFit(); calcYarn(); calcHat(); }

  fields.forEach(function (el) {
    var ev = el.tagName === 'SELECT' ? 'change' : 'input';
    el.addEventListener(ev, function () { saveInputs(); recalcAll(); });
  });

  restoreInputs();
  openFilledDisclosures();
  paintUnitLabels();
  selectTab(store.get(KEY_TAB) || 'size', false);
  recalcAll();

  /* Already unlocked on this device: straight into the toolkit. */
  if (store.get(KEY_UNLOCKED) === '1') unlock(false);

  /* ============================================================ PRINT */
  var printBtn = $('[data-ekct-print]');
  if (printBtn) printBtn.addEventListener('click', function () { window.print(); });
})();
